import { api } from './client';
import { API_BASE_URL } from '../config/api';

const base = (path) => `${API_BASE_URL}${path.startsWith('/') ? path : `/${path}`}`;

export async function submitContactForm(body) {
  const { data } = await api.post(base('/web/contact'), body, { timeoutMs: 25000 });
  return data;
}

export async function fetchGoogleReviews() {
  const { data } = await api.get(base('/web/reviews/google'), { timeoutMs: 20000 });
  return data;
}

export async function fetchWebTestimonials() {
  const { data } = await api.get(base('/api/web-testimonials/active'), { timeoutMs: 20000 });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function fetchWebReviewStats() {
  const { data } = await api.get(base('/api/web-review-stats/active'), { timeoutMs: 20000 });
  return Array.isArray(data?.data) ? data.data : [];
}

export async function lookupTrackingCode(code) {
  const { data } = await api.get(base(`/web/lookup/${encodeURIComponent(code)}`), {
    timeoutMs: 20000,
  });
  return data;
}

/** DigiRasa API Razorpay → SPA redirect callback. */
export function buildDigirasaRazorpayCallbackUrl(orderNumber) {
  if (!orderNumber) return '';
  return `${API_BASE_URL}/web/payment/razorpay-callback?orderNumber=${encodeURIComponent(orderNumber)}`;
}
